/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';

type DateInputProps = {
  label: string;
  value;
  name: string;
  disabled: boolean;
  onblurfunc: () => void;
};

const dateInput = (props: DateInputProps) => {
  const { LDCFunctions } = useLDCContext();
  const { handleLDCChange, setEditingInProcess, handleDateOnBlur } = LDCFunctions;
  const { label, value, name, disabled, onblurfunc = null } = props;

  return (
    <input
      type='date'
      value={value}
      onClick={(e) => {
        setEditingInProcess(true);
      }}
      onChange={(e) => {
        handleLDCChange('edit', name, e.target.value);
      }}
      onBlur={(e) => {
        handleDateOnBlur(e, label, name, onblurfunc);
      }}
      disabled={disabled}
    />
  );
};

export default dateInput;
